import React from 'react';
import { SidebarPortal } from '@plone/volto/components';

import BannerSidebar from './BannerSidebar';
import View from './BlockView';


const Edit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <div className={'block banner'}>
      <View {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <BannerSidebar data={data} block={block} onChangeBlock={onChangeBlock} />
      </SidebarPortal>
    </div>
  );
};

export default Edit;
